import MailStatsSdk from '@mail/stats-sdk';
import pkg from '../../package.json';

const mailStatsTongji = new MailStatsSdk({
    dataSource: 'mail' // mail、performance、mail-test、performance-test
});

// 初始化
mailStatsTongji.config({
    application: 'free_accountsRepair_c48a2b0b4523c7b3',
    appVersion: '1.0.0',
    options: {
        codelessTracking: false,
    }
});

const packageName = pkg.name || '';
// 挂载到全局
window.mailStatsTongji = mailStatsTongji;

// countly & hubble 双写
window.mailStats = {
    setAccount: (uid) => {
        window.mailStatsTongji && window.mailStatsTongji?.setAccount?.(uid);
    },
    setUid: (uid) => {
        window.mailStatsTongji && window.mailStatsTongji.setUid(uid);
    },
    pv: (key, value) => {
        window.mailStatsTongji && window.mailStatsTongji.pv(key, value);
    },
    click: (key, value) => {
        window.mailStatsTongji && window.mailStatsTongji.click(key, value);
    },
    show: (key, value) => {
        window.mailStatsTongji && window.mailStatsTongji.show(key, value);
    },
    hide: (key, value) => {
        window.mailStatsTongji && window.mailStatsTongji.hide(key, value);
    },
    performance: (key, value, action) => {
        window.mailStatsTongji && window.mailStatsTongji.performance(key, value, action);
    }
}


document.addEventListener('click', (e) => {
    let currentEle = e.target;
    while (currentEle && currentEle !== document) {
        const statsKey = currentEle.getAttribute('data-stats-key');
        let statsValue = currentEle.getAttribute('data-stats-value');

        if (statsKey) {
            try {
                statsValue = JSON.parse(statsValue || '');
            } catch (error) {
                statsValue = '';
                console.warn('统计埋点值必须为 JSON 格式');
            }
        }
        if (statsKey) {
            window.mailStats.click(statsKey, statsValue, 'click', e);
        }
        currentEle = currentEle.parentNode;
    }
})
